export default __webpack_public_path__ + "static/pc1-3-da59896f99a1b1c9b3c10aa632622fcc.jpg";